<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper' style="margin-bottom: 16px;">

      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row>
          <!-- 第一行：主要筛选条件 -->
          <a-col :md="7" :sm="24">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'loanTime')">
              <a-range-picker
                v-model='queryParam.lendingTime'
                format='YYYY-MM-DD'/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'custType')">
              <a-select default-value=''  v-model='queryParam.custType' style="width: 80%" >
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='1'>
                  新户
                </a-select-option>
                <a-select-option value='2'>
                  老户
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'orderType')">
              <a-select default-value=''  v-model='queryParam.orderType' style="width: 80%">
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='0'>
                  正常订单
                </a-select-option>
                <a-select-option value='1'>
                  展期订单
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <!-- 第二行：产品和币种 -->
          <a-col :md="7" :sm="12">
            <a-form-item :label="'主产品'">
              <a-select mode='multiple'
                        v-model='queryParam.mainSids'
                        placeholder="请选择主产品"
                        style="width: 80%"
              >
                <a-select-option v-for='item in mainAppList' :key='item.appssid' style="width: 80%">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'ProductType')">
              <a-select mode='multiple'
                        v-model='queryParam.appSsids'
                        placeholder="请选择包名"
                        style="width: 80%"
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item label="币种" style="margin-bottom: 0;">
              <a-radio-group v-model="currencyCode" @change="onCurrencyChange" button-style="solid">
                <a-radio-button value="LOCAL">本币</a-radio-button>
                <a-radio-button value="CNY">人民币 ({{ cnyRate }})</a-radio-button>
                <a-radio-button value="USD">美金 ({{ usdRate }})</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>

          <!-- 第三行：操作按钮 -->
          <a-col :md="18" :sm="24" >
            <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
            <a-button @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            <a-button type='primary' @click="downLoadData('')" icon='download' style='margin-left: 8px'>
              {{ $t('exportFile') }}
            </a-button>
          </a-col>
        </a-row>

      </a-form>
    </div>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :rowClassName='rowClassName'
        :pagination='false'
        :loading='loading'
        bordered>
      </a-table>


    <v-modal
      v-model='visible'
      :title="$t('order.collectionDetail')">
      <div style='padding: 20px;'>
        <collection-detail
          v-if='visible'
          :orderId='orderId'
          :custInfoId='custInfoId'
          :taskId='taskId'
          :auditDrawer='false'
          @close='visible = false;' />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { countPlatformLoanDataWithDate, getApplistExcludingSubApp, getApplist } from '@/webpublicapi/order'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import exportFile from '@/webpublicapi/exportFile'
import { exportFileByPost } from '@/api/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal'
import {getExchangeRate} from "@/webpublicapi/statistics";

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'CountCollectionTaskDispense',
  components: {
    Dict,
    DictSelect,
    vModal
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      exportParams: '',
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,

      currencyCode: 'LOCAL', // 当前货币代码：LOCAL-本币，CNY-人民币，USD-美金
      exchangeRate: 1, // 当前使用的汇率
      cnyRate: 1, // 人民币汇率（缓存）
      usdRate: 1, // 美金汇率（缓存）

      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      appList: [],
      mainAppList: [],
      deadlineConfigList: [],
      // 查询条件
      queryParam: {
        mainSids: [],
        'deadlineConfigValue':'',
        'orderNo': '',
        'appssid': '',
        'appSsids': [],
        'mobileNo': '',
        'orderType': ''
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [

        {
          title: this.$t('order.loanDate'),
          align: 'left',
          dataIndex: 'paymentTime'
        },
        {
          title: this.$t('order.loanPensNum'),
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: this.$t('order.newAcountsNum'),
          align: 'left',
          dataIndex: 'newLoanCount'
        },
        {
          title: this.$t('order.Newhouseholdpartsareall'),
          align: 'left',
          dataIndex: 'jianjunNew'
        },
        {
          title: this.$t('order.oldAcountsNum'),
          align: 'left',
          dataIndex: 'oldLoanCount'
        },
        {
          title: this.$t('order.Oldhouseholdpartsareall'),
          align: 'left',
          dataIndex: 'jianjunOld',
          customRender: this.convertAmount
        },
        {
          title: this.$t('order.ProportionOfOldHouseholds'),
          align: 'left',
          dataIndex: 'noRate'
        },
        {
          title: this.$t('order.loanPrincipal'),
          align: 'left',
          dataIndex: 'paymentAmt',
          customRender: this.convertAmount
        },
        {
          title: this.$t('order.NewHouseholdsPrincipalOfl'),
          align: 'left',
          dataIndex: 'newPaymentAmt',
          customRender: this.convertAmount
        },
        {
          title: this.$t('order.OldHouseholdsPrincipalOfl'),
          align: 'left',
          dataIndex: 'oldPaymentAmt',
          customRender: this.convertAmount
        },
        {
          title: this.$t('order.LoanContractAmount'),
          align: 'left',
          dataIndex: 'applyAmt',
          customRender: this.convertAmount
        },
        {
          title: this.$t('order.NewHouseholdContractAmount'),
          align: 'left',
          dataIndex: 'newApplyAmt',
          customRender: this.convertAmount
        },
        {
          title: this.$t('order.OldHouseholdContractAmount'),
          align: 'left',
          dataIndex: 'oldApplyAmt',
          customRender: this.convertAmount
        }
      ]
    }
  },
  created() {
    getApplist().then(res => {
      this.appList = res.data || []
    })
    this.getDict()
    this.initAllRates()
    this.loadData()
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || []
    });
    getApplistExcludingSubApp().then(res => {
      this.mainAppList = []
      this.mainInAppList = res.data || []
      for (var i = 0; i < this.mainInAppList.length; i++) {
        if (this.mainInAppList[i].appssid != '') {
          this.mainAppList.push(this.mainInAppList[i])
        }
      }
    })
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      console.log('params--->', params)
      countPlatformLoanDataWithDate(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          // this.total = res.data.total
          this.dataSource = res.data || []
          if (this.dataSource.length > 0) {
            for (var i = 0; i < this.dataSource.length; i++) {
              var dataO = this.dataSource[i]

              dataO.jianjunOld = (dataO.oldApplyAmt / dataO.oldLoanCount).toFixed(1)
              dataO.jianjunNew = (dataO.newApplyAmt / dataO.newLoanCount).toFixed(1)

            }
          }
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { lendingTime } = this.queryParam
      const data = {
        ...this.queryParam,
        lendingTimeStart: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[0]) : undefined,
        lendingTimeEnd: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[1]) : undefined
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.lendingTime = undefined
      that.queryParam.custType = ''
      that.queryParam.orderType = ''
      that.queryParam.appssid = ''
      that.queryParam.deadlineConfigValue=''
      that.queryParam.appSsids = []
      that.queryParam.mainSids = []
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleMainSids(params) {
      var mainSidsValue = params['mainSids'];
      if(mainSidsValue != null && mainSidsValue != '' && mainSidsValue != undefined && mainSidsValue.length > 0) {
        var mains = mainSidsValue[0];
        for(var item in mainSidsValue) {
          if(item != '0') {
            mains = mains + '_' + mainSidsValue[item];
          }
        }
        params['mainSids'] = mains;
      }
      return params;
    },
    handleAppssids(params) {
      var appssidsValue = params['appSsids'];
      if(appssidsValue != null && appssidsValue != '' && appssidsValue != undefined && appssidsValue.length > 0) {
        var apps = appssidsValue[0];
        for(var item in appssidsValue) {
          if(item != '0') {
            apps = apps + '_' + appssidsValue[item];
          }
        }
        params['appSsids'] = apps;
      }
      return params;
    },
    async downLoadData() {
      var params = this.getQueryParams()// 查询条件
      this.loading = true
      try {
        const result = await exportFileByPost(
          `/api/web/webpublic/platform/order/countLoanDataWithDateExcel`,
          params,
          "countLoanDataWithDateExcel.xlsx"
        );
        if (result instanceof Error) {
          this.$message.error(result.message);
        }
      } catch(error) {
          this.$message.error(error.message);
      } finally{
        this.loading = false
      }
    },
    rowClassName(record, index) {
      var date = new Date(record.curDate)
      var day = date.getTime() / 24 / 60 / 60 / 1000 + 3
      console.log(record.curDate, date, (day % 7) + 1)

      if ((day % 7) + 1 == 7) {
        return 'table_weekendColor'
      }
      return ''
    },

    // 初始化所有汇率（页面加载时执行）
    initAllRates () {
      const currency = process.env.VUE_APP_CURRENCY
      console.log('currency--->', currency)
      if(!currency)
        return

      getExchangeRate({currency: currency}).then((res)=>{
        if(res.code===1000){

          this.data = res.data || [];

          this.cnyRate = this.data['CNY'] || 1
          this.usdRate = this.data['USD'] || 1
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },

    // 货币切换处理
    onCurrencyChange (e) {
      const selectedCurrency = e.target.value

      switch (selectedCurrency) {
        case 'LOCAL':
          this.exchangeRate = 1
          this.$message.info('已切换为本币')
          break
        case 'CNY':
          if (this.cnyRate !== null && this.cnyRate !== undefined) {
            this.exchangeRate = this.cnyRate
            this.$message.success(`已切换到人民币，汇率：${this.cnyRate}`)
          } else {
            this.$message.warning('人民币汇率未加载')
          }
          break
        case 'USD':
          if (this.usdRate !== null && this.usdRate !== undefined) {
            this.exchangeRate = this.usdRate
            this.$message.success(`已切换到人民币，汇率：${this.usdRate}`)
          } else {
            this.$message.warning('美金汇率未加载')
          }
          break
      }
    },

    // 汇率转换格式化方法（使用公共工具）
    convertAmount (text) {
      return this.$convertCurrency(text, this.exchangeRate)
    },


  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
